"use strict";
/**
 * Created by marvin.ruppelt on 24.09.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var GridComponent_1 = __importDefault(require("./GridComponent"));
var actions_1 = require("../../actions");
var Pagination_1 = require("../Pagination");
var GridWrapper = function (_a) {
    var changeLocation = _a.changeLocation, data = _a.data, rest = __rest(_a, ["changeLocation", "data"]);
    var history = (0, react_router_dom_1.useHistory)();
    var currentLocation = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        return history.listen(function (location) {
            changeLocation(location);
        });
    }, [history]);
    (0, react_1.useEffect)(function () {
        if (data === undefined || data === null || data.length === 0) {
            changeLocation(currentLocation);
        }
    }, []);
    // @ts-ignore
    return react_1["default"].createElement(GridComponent_1["default"], __assign({ data: data }, rest));
};
var mapState = function (_a, _b) {
    var gridState = _a.grid;
    var grid = _b.grid;
    return ({
        selection: gridState[grid] && gridState[grid].selection || []
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    initializeGrid: function (grid) { return dispatch((0, actions_1.initializeGrid)(grid)); },
    destroyGrid: function (grid) { return dispatch((0, actions_1.destroyGrid)(grid)); },
    changeData: function (grid, data) { return dispatch((0, actions_1.changeData)(grid, data)); },
    changeLocation: function (location) { return dispatch((0, actions_1.changeLocation)(location)); }
}); };
var Grid = (0, react_redux_1.connect)(mapState, mapDispatchToProps)(GridWrapper);
var GridContainer = function (_a) {
    var children = _a.children, data = _a.data, isLoading = _a.isLoading, pagination = _a.pagination, grid = _a.grid, _b = _a.pageSizes, pageSizes = _b === void 0 ? [10, 20, 50] : _b, _c = _a.paginationAfterGrid, paginationAfterGrid = _c === void 0 ? false : _c, _d = _a.paginationCountFormat, paginationCountFormat = _d === void 0 ? Pagination_1.PAGINATION_COUNT_FORMAT_SHORT : _d, rest = __rest(_a, ["children", "data", "isLoading", "pagination", "grid", "pageSizes", "paginationAfterGrid", "paginationCountFormat"]);
    return (
    //  @ts-ignore
    react_1["default"].createElement(Grid, __assign({ data: data, isLoading: isLoading, pagination: pagination, grid: grid, pageSizes: pageSizes, paginationAfterGrid: paginationAfterGrid, paginationCountFormat: paginationCountFormat }, rest), children));
};
exports["default"] = GridContainer;
